import { FC, useEffect } from 'react'
import { AnimatedPage } from 'components/Animated'
import { useVideoCallsFlowContext } from 'screens/VideoCalls/context/VideoCallFlowContext'
import { useFindCurrentStep } from 'screens/VideoCalls/hooks/useFindCurrentStep'
import { notifyFlowExited } from 'utils/crossOriginMessaging'

export const VideoCallFlowStep: FC<any> = ({ isKeggFlow }) => {
  // The step and its props come from the URL, so the screen always matches it.
  const { index: stepIndex, step: currentStep } = useFindCurrentStep()
  const StepComponent = currentStep.routeComponent
  const props = currentStep.props ?? {}

  const { direction, resetBackDirection, registerCallback } = useVideoCallsFlowContext()

  useEffect(() => {
    if (!isKeggFlow) {
      return
    }

    // loading, sign up and address state steps only
    if (stepIndex > 2) {
      return
    }

    registerCallback(() => {
      notifyFlowExited()
      return false
    })

    return () => registerCallback(() => true)
  }, [isKeggFlow, registerCallback, stepIndex])

  if (currentStep.noPageAnimation) {
    return <StepComponent {...props} />
  }

  return (
    <AnimatedPage direction={direction} resetBackDirection={resetBackDirection}>
      <StepComponent {...props} />
    </AnimatedPage>
  )
}
